/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Shared constants for the reporting system</blockquote>
 * 
 * @example
 * ```typescript
 * import { 
 *   SERVICE_REGISTRY_MESSAGES,
 *   POSTHOG_CONFIG,
 *   POSTHOG_MESSAGES 
 * } from '@shared/reporting';
 * ```
 */

/** @internal */
export * from './SERVICE_REGISTRY_MESSAGES';
/** @internal */
export * from './VALIDATION_MESSAGES';
/** @internal */
export * from './POSTHOG_MESSAGES';
/** @internal */
export * from './POSTHOG_CONFIG';
/** @internal */
export * from './POSTHOG_FIELDS';
/** @internal */
export * from './CONSOLE_TABLE';
/** @internal */
export * from './CONSOLE_MESSAGES';
/** @internal */
export * from './CONSOLE_FIELDS';
/** @internal */
export * from './CONSOLE_FORMATS'; 